// extracted by mini-css-extract-plugin
export default {"root":"Fit_root__ANDdN","title":"Fit_title__1-61v","bars":"Fit_bars__3agZT","bar":"Fit_bar__3_Fmx","darkBar":"Fit_darkBar__3DZHN","labels":"Fit_labels__Uy5g9"};